import { NavLink, useNavigate } from "react-router-dom";
import styles from './index.module.css';
import LogoImg from '../../assets/images/brand/IBS landscape.png';

const Header = ({ toggleSidebar }) => {
    const navigate = useNavigate();

    const toggleStart = () => navigate('/auth/login');

    return (
        <>
            <div className={styles.navContainer}>
                <div className={styles.navBar}>
                    <div className={styles.logoSec}>
                        {/* <NavLink to={'/'}>
                            <img src={LogoImg} alt="Logo" className={styles.logoImg} />
                        </NavLink>
                        | IBS Official Certificate Verification Portal */}
                        <table>
                            <thead>
                                <tr>
                                    <td style={{display: 'flex', alignItems: 'center'}}>
                                            <img src={LogoImg} alt="Logo" className={styles.logoImg} />
                                    </td>
                                    <td className={styles.leftBorderCell}>IBS Official Certificate Verification Portal</td>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Header;